<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Leave Reports</h5>
  </div>
<div class="" *ngIf="showData">
<div id="mainContent" class="container" >
  <div class="modal-body">
    <form [formGroup]="leaveForm">
      <div class="row">
        <div class="col-sm-5">
          <div class="row">
            <label for="fyName" class="col-sm-4 col-form-label"
              >Financial Year : <span class="text-danger">*</span></label
            >
            <div class="col-sm-7">
              <select
                formControlName="fy"
                class="form-control form-control-xs mt-1"
                id="fy"
                name="fy"
              >
                <option value="">Select Financial Year</option>
                <option *ngFor="let fy of financialYearList" [ngValue]="fy">
                  {{ fy.name }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="col-sm-2">
          <button
            id="saveFyBtn"
            name="saveFyBtn"
            type="button"
            class="btn btn-sm btn-block btn-outline-theme"
            (click)="onViewReport()"
          >
            View Report
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
<br>
    <div class="container" id="mainContent" *ngIf="showReports">
      <div class="row pt-3">
        <div class="col-md-10">
          <span style="padding-left: 40%" class="bg-theme-title"
            >Leave Deatils of FY year : {{ fyName }} </span
          ><br />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-9"><span class="" style="font-weight: bold;font-size: 14px;">
              Employee Name : </span>{{ uFName }} {{ uMName != "null" ? uMName : "" }}
              {{ uLName }}
          </div>
            <div class="col-md-3"><span style="font-weight: bold;font-size: 14px;">Employee Type :</span>  {{ uType }} </div>
          </div>

          <table
            class="table table-sm table-bordered table-striped"
            style="padding-left: 25%; overflow-x: auto; white-space: nowrap"
          >
            <thead class="">
              <tr>
                <th>Month-Year</th>
                <th>Opening Balance</th>
                <th>Leaves Taken</th>
                <th>Closing Balance</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let rep of reports">
                <td (click)="getPerticularUserDetails(rep.month, rep.year)">
                  <a style="cursor: pointer; color: #800000"
                    >{{ rep.month }}-{{ rep.year }}</a
                  >
                </td>
                <td>{{ rep.openingBalance }}</td>
                <td>{{ rep.leavesTaken }}</td>
                <td>{{ rep.closingBalance }}</td>
              </tr>
              <tr *ngIf="reports.length == 0">
                <td colspan="4" style="text-align: center">
                  No Entries available
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    </div>

  
    <div class="container" id="mainContent" *ngIf="!showData">
      <div class="row pt-3">
        <div class="col-md-4" (click)="goBack()">
          <i class="fa fa-arrow-circle-o-left fa-2x"></i>
        </div>
        <div class="col-md-8">
          <span class="bg-theme-title">Employee / Article Leave Details</span>
        </div>
      </div>
    
        <div class="row mt-2">
          <div class="col-md-12">
            <span style="font-size: 14px ;font-weight: bold;">Employee Name :</span> {{ uFName }} {{ uLName }}
        </div>
        </div>
        <div class="row">
          <div class="col-md-12">
          <table class="table table-bordered table-bordered table-striped table-sm">
            <thead>
              <tr>
                <th>Leave From Date</th>
                <th>Leave To Date</th>
                <th>Leaves Day</th>
                <th>Reason</th>
                <th>Leave Type</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of leaveDetailsList">
                <td>{{ data.fromDate | date: "dd-MM-yyyy" }}</td>
                <td>{{ data.toDate | date: "dd-MM-yyyy" }}</td>
                <td>{{ data.leaveDays }}</td>
                <td>{{ data.reason }}</td>
                <td>{{ data.leaveType }}</td>
                <td>{{ data.status }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
  </div>
</div>
